import { format } from 'date-fns';
import { SPECIAL_CATEGORIES } from '../../../SearchForm/utils';
import { AviaPassengerType } from '@websky/graphql';
import { Currency } from '../../../enums';
const PROMO_REGEX = 'PROMO([a-zA-Zа-яА-Я0-9]*?)';
const isCurrentCompanySwitchedToAutoGeneration = () => {
    var _a, _b, _c;
    return ['ZZ', 'F7', 'D2', 'SZ', 'Y7', 'IO'].includes((_c = (_b = (_a = window.__webskyEngineConfig) === null || _a === void 0 ? void 0 : _a.global) === null || _b === void 0 ? void 0 : _b.companyInfo) === null || _c === void 0 ? void 0 : _c.iataCode);
};
export const getIATA = (data) => {
    return data.substr(0, 3);
};
export const isDateGuard = (date) => {
    return !!date.getTime;
};
export const getAbsoluteDate = (isoString) => {
    return isoString.substr(0, 19);
};
export const getDateWithoutTimezone = (date) => {
    return dateConverter(date, false);
};
export const getDateWithTimezone = (date) => {
    return dateConverter(date, true);
};
export const getAirport = (airport) => {
    var _a;
    if ((_a = airport.city) === null || _a === void 0 ? void 0 : _a.name) {
        return Object.assign(Object.assign({}, airport), { name: airport.city.name });
    }
    return airport;
};
const dateConverter = (date, withTimezone) => {
    if (isDateGuard(date)) {
        const dateWithoutTimezone = new Date(withTimezone ? date.getTime() : date.getTime() + date.getTimezoneOffset() * 60000);
        dateWithoutTimezone.setMilliseconds(0);
        return dateWithoutTimezone;
    }
    else {
        const newDate = new Date(date);
        const dateWithoutTimezone = new Date(withTimezone ? newDate.getTime() : newDate.getTime() + newDate.getTimezoneOffset() * 60000);
        dateWithoutTimezone.setMilliseconds(0);
        return dateWithoutTimezone;
    }
};
export const getDate = (data) => {
    const year = data.slice(0, 4);
    const month = data.slice(4, 6);
    const day = data.slice(6, 8);
    return getDateWithoutTimezone(`${year}-${month}-${day}`);
};
export const getPassenger = (passengersConfig, data) => {
    var _a;
    const type = data.substr(0, 3), count = parseInt(data.substr(3, 1)), isExtendedPassengerType = SPECIAL_CATEGORIES.includes(type);
    const passengerType = isExtendedPassengerType
        ? ((_a = passengersConfig.find(config => config.code === type)) === null || _a === void 0 ? void 0 : _a.parentCode) || AviaPassengerType.ADT
        : type;
    return {
        count,
        passengerType: passengerType,
        extendedPassengerType: isExtendedPassengerType ? type : null
    };
};
/**
 * Use for smooth transition to regex auto generation
 *
 * @deprecated
 */
const isPassengerNext__deprecated = (data) => {
    return /^(ADT|GCF|CLD|INF|INS|МЛА|SCM|SCF|PDA|YTH|SRC)(.)*\d/.test(data);
};
/**
 * @deprecated
 */
const isFastSearchCorrect__deprecated = (fastSearch) => {
    return /^(([A-Z]|[А-Я]){6}\d{8})+((((ADT|МЛА|CLD)\d)|((SCF|SCM|YTH|SRC|МЛА)\d)+)((GCF|CLD|INF|INS)\d)*)?((PROMO([a-zA-Zа-яА-Я0-9]+))|(PAYBYMILES))?(RUB|USD|KZT|GEL|EUR|AMD|UZS|AZN|TRY|RSD|ILS|CNY|GBP)?$/.test(fastSearch);
};
/**
 * @deprecated
 */
const _WZ_isFastSearchCorrect__deprecated = (fastSearch) => {
    return /^(([A-Z]|[А-Я]){6}\d{8})+((((ADT|PDA|CLD|INF|INS)\d)+)|((SCF|SCM|МЛА|CLD|INF|INS)\d)+)?(PROMO([a-zA-Zа-яА-Я0-9]+))?(RUB|USD|KZT)?$/.test(fastSearch);
};
export const isPassengerNext = (passengersConfig, data) => {
    const passengerTypes = passengersConfig.map(passenger => passenger.code).join('|');
    return new RegExp(`^(${passengerTypes})(.)*\\d`).test(data);
};
const isPassengerNextChecker = (passengersConfig, str) => {
    if (isCurrentCompanySwitchedToAutoGeneration()) {
        return isPassengerNext(passengersConfig, str);
    }
    else {
        return isPassengerNext__deprecated(str);
    }
};
export const hasPromo = (value) => {
    return RegExp(PROMO_REGEX).test(value);
};
export const extractPromo = (value) => {
    var _a;
    return (_a = value.match(`${PROMO_REGEX}(?=PAYBYMILES|${Object.keys(Currency).join('|')}|$)`)) === null || _a === void 0 ? void 0 : _a[1];
};
export const isPromoOrCurrencyNext = (data) => {
    const regex = new RegExp(`^((PROMO([a-zA-Zа-яА-Я0-9]+))|(PAYBYMILES))?(${Object.keys(Currency).join('|')})?$`);
    return regex.test(data);
};
export const extractPromoCodeAndCurrency = (fastSearch) => {
    const matchedResult = fastSearch.match(new RegExp(`((PROMO([a-zA-Zа-яА-Я0-9]+?))|(PAYBYMILES))?(${Object.keys(Currency).join('|')})?$`));
    return {
        promoCode: (matchedResult === null || matchedResult === void 0 ? void 0 : matchedResult[3]) || '',
        payByMiles: (matchedResult === null || matchedResult === void 0 ? void 0 : matchedResult[4]) === 'PAYBYMILES',
        currency: (matchedResult === null || matchedResult === void 0 ? void 0 : matchedResult[5]) || ''
    };
};
export const fastSearchParse = (fastSearch, passengersConfig, allowPromoCodes) => {
    let str = fastSearch;
    const segments = [], passengers = [];
    while (!isPassengerNextChecker(passengersConfig, str) && !isPromoOrCurrencyNext(str) && str.length) {
        const departure = getIATA(str), arrival = getIATA(str.slice(3)), date = getDate(str.slice(6));
        segments.push({
            arrival: {
                iata: arrival
            },
            departure: {
                iata: departure
            },
            date: format(date, 'yyyy-MM-dd')
        });
        str = str.slice(14);
    }
    while (isPassengerNextChecker(passengersConfig, str)) {
        passengers.push(getPassenger(passengersConfig, str));
        str = str.slice(4);
    }
    if (!passengers.length) {
        passengers.push({
            passengerType: AviaPassengerType.ADT,
            count: 1
        });
    }
    const result = {
        segments,
        passengers
    };
    const { promoCode, payByMiles, currency } = extractPromoCodeAndCurrency(fastSearch);
    if (allowPromoCodes && promoCode) {
        result.promotionCode = promoCode;
    }
    if (currency) {
        result.currency = currency;
    }
    result.ffpMode = payByMiles;
    return result;
};
export const generateFastSearchRegex = (config) => {
    const airportsAndDatesRegex = `(([A-Z]|[А-Я]){6}\\d{8})+`;
    const passengerTypes = config.SearchForm.passengersConfig.map(passenger => passenger.code).join('|');
    const passengersRegex = `(((${passengerTypes})\\d)+)?`;
    const promo = config.global.allowPromoCodes ? '(PROMO([a-zA-Zа-яА-Я0-9]+?))' : '';
    const payByMiles = config.SearchForm.payByMiles ? '(PAYBYMILES)' : '';
    const promoAndMilesArr = [promo, payByMiles].filter(Boolean);
    const promoAndMilesRegex = promoAndMilesArr.length ? `(${promoAndMilesArr.join('|')})?` : '';
    const currencyRegex = `(${Object.values(Currency).join('|')})?`;
    return new RegExp(`^${airportsAndDatesRegex}${passengersRegex}${promoAndMilesRegex}${currencyRegex}$`);
};
export const isFastSearchCorrect = (config, fastSearch) => {
    var _a;
    if (isCurrentCompanySwitchedToAutoGeneration()) {
        const regex = generateFastSearchRegex(config);
        return regex.test(fastSearch);
    }
    else if (((_a = config.global.companyInfo) === null || _a === void 0 ? void 0 : _a.iataCode) === 'WZ') {
        return _WZ_isFastSearchCorrect__deprecated(fastSearch);
    }
    else {
        return isFastSearchCorrect__deprecated(fastSearch);
    }
};
